import React from 'react';
import styles from './Sponsorship.module.scss';

import { Badge } from '@eventbrite/legacy-eds.badge';
import { gettext } from '@eventbrite/legacy-infra.i18n';

export const Sponsorship = () => (
    <div>
        <span>{gettext('Sponsorships').toString()}</span>
        <span className={styles.containerSpacing}>
            <Badge text={gettext('Beta').toString()} bgColor="ui-600" />
        </span>
    </div>
);
